import { useEffect, useRef, useState } from 'react'
import { useSessionStore, useUIStore, useCartStore } from '@/stores'
import { SessionResult } from '@/constants'

// Shared by every logout screen so each portal's teardown is identical and only the
// chrome around it differs. Returns false until the session has been torn down.
export const useLogoutSequence = (message: string): boolean => {
  const [ready, setReady] = useState(false)
  const didRun = useRef(false)

  useEffect(() => {
    if (didRun.current) {
      return
    }
    didRun.current = true

    const uiStore = useUIStore.getState()
    uiStore.clearError()

    const doLogout = async () => {
      const sessionStore = useSessionStore.getState()
      if (sessionStore.isSessionActive()) {
        uiStore.setLoading(true)
        try {
          await sessionStore.updateSession({ result: SessionResult.Logout, message })
        } catch {
          // continue regardless
        } finally {
          uiStore.setLoading(false)
        }
      }
      useSessionStore.getState().logout()
      useCartStore.getState().clearCart()
      setReady(true)
    }

    doLogout()
    // eslint-disable-next-line react-hooks/exhaustive-deps -- Mount-only logout sequence.
  }, [])

  return ready
}
